import {OrganizedSettings} from './types';

export const SUPPORTED_WORKSPACE_SPEC_VERSION = 1;

const LINE_PLOT_SETTING_FIELDS = [
  'colorRunNames',
  'maxRuns',
  'ignoreOutliers',
  'pointVisualizationMethod',
  'highlightedCompanionRunOnly',
  'suppressLegends',
  'showMinMaxOnHover',
  'tooltipNumberOfRuns',
  'xAxis',
  'xAxisMin',
  'xAxisMax',
  'smoothingWeight',
  'smoothingType',
];
const ACTIVE_SETTING_FIELDS = [
  'localSmoothingSettingsActive',
  'localxAxisSettingsActive',
  'smoothingActive',
  'xAxisActive',
];
/**
 * This is temporary migration logic. Do not use this function further.
 */
export const getOrganizedSettings = (
  settings: Record<string, any>
): OrganizedSettings => {
  const newWorkspaceSettings: Record<string, any> = {};
  for (const [key, value] of Object.entries(settings)) {
    // Exclude `xAxisActive`, `smoothingActive`, etc
    // Also don't include the refs since they're internal values
    if (ACTIVE_SETTING_FIELDS.indexOf(key) > -1 || key === 'ref') {
      continue;
    }

    // Add line specific plot settings into a separate field
    if (LINE_PLOT_SETTING_FIELDS.indexOf(key) > -1) {
      if (!('linePlot' in newWorkspaceSettings)) {
        newWorkspaceSettings.linePlot = {};
      }
      newWorkspaceSettings.linePlot[key] = value;
      continue;
    }

    newWorkspaceSettings[key] = value;
  }
  return newWorkspaceSettings;
};
